{
  "version": 1,
  "asset_id": "864f7327-962f-499c-96fe-36284fb70833",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/864f7327-962f-499c-96fe-36284fb70833/beverly-hills-shingle-roof-underlayment-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/864f7327-962f-499c-96fe-36284fb70833/beverly-hills-shingle-roof-underlayment-768w.webp",
  "original_filename": "beverly-hills-shingle-roof-underlayment-768w.webp",
  "size": 75862,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:29Z"
}
